"use client";

import { Editor } from "@tiptap/react";
import { createContext, Dispatch, SetStateAction } from "react";

export interface IEditorContext {
  editor: Editor | null;
  setEditor: Dispatch<SetStateAction<Editor>>;
  saveStatus: string;
  setSaveStatus: Dispatch<SetStateAction<string>>;
}

export const EditorContext = createContext<IEditorContext>({
  editor: null,
  setEditor: () => {},
  saveStatus: "Unsaved",
  setSaveStatus: () => {},
});
